import React, {FC, useEffect, useState} from 'react'
import {CopyToClipboard} from 'react-copy-to-clipboard'
import {useSelector} from 'react-redux'
import {select_databaseIdToCopy, select_showBulkEditPanel} from 'redux/databases/selectors'
import {useAppDispatch} from 'redux/config'
import {fetchDatabaseDetails, databasesAC} from 'redux/databases/databases.duck'

import {CellPropsType} from './cellPropsType'

import {
  Icon,
  Link,
  Tooltip,
} from '@mdsol/onex-design'

import './databaseId.scss'

const DatabaseId: FC<CellPropsType> = ({cell}) => {
  const databaseId = cell.getValue()
  const dispatch = useAppDispatch()

  const databaseIdToCopy = useSelector(select_databaseIdToCopy)
  const showBulkEdit = useSelector(select_showBulkEditPanel)
  const [copied, setCopied] = useState(false)

  const displayRowDetails = () => {
    if(showBulkEdit) {
      dispatch(databasesAC.clearBulkEditForm())
      dispatch(databasesAC.hideBulkEditPanel())
    }
    if (databaseIdToCopy === databaseId) {
      dispatch(databasesAC.toggleDatabaseDetails())
      dispatch(databasesAC.databaseIdToCopyApplied(''))
    } else {
      dispatch(fetchDatabaseDetails(databaseId))
      dispatch(databasesAC.showDatabaseDetails())
      dispatch(databasesAC.databaseIdToCopyApplied(databaseId))
    }
  }

  const handleCopy = () => {
    setCopied(true)
  }

  useEffect(() => {
    let timeoutCopy

    if(copied) {
      timeoutCopy = setTimeout(() => {
        setCopied(false)
      }, 1000)
      dispatch(databasesAC.databaseIdCopiedTimerApplied(timeoutCopy))
    }

    return () => {
      clearTimeout(timeoutCopy)
    }
  }, [copied, dispatch])

  return (
    <>
      <Link
        key={`link-database-details-${databaseId}`}
        dataTestId='database-details-link'
        variant='secondary'
        onClick={displayRowDetails}
      >
        {databaseId}
      </Link>

      <div data-testid='copy-container' className='copy-container'>
        {!copied && <CopyToClipboard
          onCopy={handleCopy}
          text={databaseId}
        >
          <Icon data-testid='copy-icon'>content_copy</Icon>
        </CopyToClipboard>}

        {copied && <Tooltip
          dataTestId='tooltip-database-id-copied'
          id={`tooltip-database-id-copied--${databaseId}`}
          show={copied}
          placement='top-start'
          tooltipChildren='Copied!'
        >
          <Icon className='icon-copied'>check</Icon>
        </Tooltip>
        }
      </div>
    </>
  )
}

export default DatabaseId
